import { useState, useEffect } from "react";
import { getAgreementAll, searchAgreements } from "../services/agreementServices";

function useAgreementsData(searchTerm = "", page = 1, status = "all", filters = {}, refreshKey = 0) {
  const [agreements, setAgreements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalAgreements, setTotalAgreements] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const {
    typeFilter,
    subscriptionFrom,
    subscriptionTo,
    validityFrom,
    validityTo,
  } = filters;

  useEffect(() => {
    async function loadAgreements() {
      setLoading(true);
      try {
        const hasFilters =
          (searchTerm && searchTerm.trim() !== "") ||
          status !== "all" ||
          typeFilter ||
          subscriptionFrom ||
          subscriptionTo ||
          validityFrom ||
          validityTo;

        const query = searchTerm && searchTerm.trim() !== "" ? searchTerm : "*";

        const response = hasFilters
          ? await searchAgreements(query, page, status, filters)
          : await getAgreementAll(page);

        if (response?.data) {
          const data = response.data.data;
          
          setAgreements(data.agreements || []);
          setTotalAgreements(data.total_count || 0);
        } else {
          setAgreements([]);
          setTotalAgreements(0);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    loadAgreements();
  }, [
    searchTerm,
    page,
    status,
    typeFilter,
    subscriptionFrom,
    subscriptionTo,
    validityFrom,
    validityTo,
    refreshKey,
  ]);

  return { agreements, loading, error, totalAgreements, perPage };
}

export default useAgreementsData;
